import styled from '@emotion/styled';
import { BackButton } from 'components';
import { PropsWithChildren } from 'react';

const HeaderContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 6fr 1fr;
    gap: ${({ theme }) => theme.base.spacing[1]};
    margin-bottom: ${({ theme }) => theme.base.spacing[6]};
    background-color: ${({ theme }) => theme.base.color.backgroundMain};
`;

const HeaderLeft = styled.div`
    display: flex;
    align-items: center;
    grid-row-start: 1;
`;

const HeaderCenter = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    grid-column-start: 2;
`;
const HeaderRight = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    grid-column-start: 3;
`;

const Back = styled(BackButton)`
    width: auto;
    background: none;
`;

interface HeaderComposition {
    Left: typeof HeaderLeft;
    Center: typeof HeaderLeft;
    Right: typeof HeaderCenter;
    Back: typeof Back;
}

const Header: React.FunctionComponent<PropsWithChildren> & HeaderComposition = ({
    children,
    ...othProps
}) => {
    return <HeaderContainer {...othProps}>{children}</HeaderContainer>;
};

Header.Left = HeaderLeft;
Header.Center = HeaderCenter;
Header.Right = HeaderRight;
Header.Back = Back;

export default Header;
